import React from "react";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../../assests/images/hero-img1.png";
import "./hero-section.css";

const HeroSection = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="hero__content">
              <h2 className="mb-4 hero__title">
                YOU DREAM IT... WE BUILT IT!!!
              </h2>
              <p className="mb-5">
              "Welcome to Appkida Technologies, where innovation meets excellence! We are your go-to destination for cutting-edge app and website development solutions. Committed to fostering talent, we also provide top-notch training and internship programs to shape the tech leaders of tomorrow."
              </p>
            </div>
            {/* <div className="search">
              <input type="text" placeholder="Search" />
              <button className="btn">Search</button>
            </div> */}
          </Col>

          <Col lg="6" md="6">
            <img src={heroImg} alt="" className="w-100 hero__img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
